import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';

function useManageNotification() {
  const history = useHistory();
  const queryClient = useQueryClient();
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function addNotification(data) {
    return privateFetch.post(`/v1/admin/notification`, data);
  }

  function updateNotification(notificationId, data) {
    return privateFetch.put(`/v1/admin/notification/${notificationId}`, data);
  }

  function manageNotification({ data, notificationId }) {
    if (notificationId) {
      return updateNotification(notificationId, data);
    }

    return addNotification(data);
  }

  return useMutation(manageNotification, {
    onSuccess() {
      history.goBack();
    },
    onSettled() {
      queryClient.invalidateQueries('notification-lists');
    },
  });
}

export default useManageNotification;
